import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";

const FILTERS = ["", "paid", "pending", "redeemed", "cancelled", "refunded"];

export default function PayAppHistory() {
  const { ApiBaseUrl, setIsLoginShow } = useContext(MyContext);
  const Userid = secureLocalStorage.getItem("Userid");
  const [filter, setFilter] = useState("");
  const [txns, setTxns] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!Userid) { setIsLoginShow(true); return; }
    axios.post(`${ApiBaseUrl}/pv/customer/txn/list`, { customer_id: Userid, filter: filter || undefined })
      .then((r) => setTxns(r.data.txns || []));
  }, [filter, Userid, ApiBaseUrl]);

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-rm-ink mb-4">Payment history</h1>
      <div className="flex flex-wrap gap-2 mb-4">
        {FILTERS.map((f) => (
          <button key={f || "all"} className={`px-3 py-1 rounded border ${filter === f ? "bg-rm-primary text-white" : ""}`}
            onClick={() => setFilter(f)}>{f || "all"}</button>
        ))}
      </div>
      <div className="space-y-3">
        {txns.map((t) => (
          <div key={t.id} className="border rounded-xl p-4 bg-white cursor-pointer" onClick={() => navigate(`/pay-app/txn/${t.id}`)}>
            <div className="flex justify-between">
              <div>
                <p className="font-semibold">{t.partner_name}</p>
                <p className="text-sm text-gray-500">{t.txn_code}</p>
              </div>
              <div className="text-right">
                <p className="font-bold">₹{t.payable_amount}</p>
                <p className="text-xs">{t.status}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {!txns.length && <p className="text-center text-gray-500 py-10">No transactions</p>}
    </div>
  );
}
